import { queryOptions, UseQueryOptions } from '@tanstack/react-query'
import { RatingsAndReviewsService, RatingsReviewsResponse } from 'services/RatingsAndReviewsService'

export const QUERY_KEY = 'ratings_and_reviews'

export const queryRatings = (locale: i18n.Locale, mpvId: string, options?: Omit<UseQueryOptions<RatingsReviewsResponse>, 'queryKey'>) =>
  queryOptions({
    queryKey: [QUERY_KEY, { locale, mpvId }],
    queryFn: async () => RatingsAndReviewsService.getRatingsAndReviews(locale, mpvId),
    select: ({ reviewsCount, averageRating }) => ({ reviewsCount, averageRating }),
    ...options,
  })
